import { modifyCounsilors } from "api/counsilors";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputComp from "themes/elements/Input";
import InputPhoneNumber from "themes/elements/InputPhoneNumber";
import ModalComp from "themes/elements/Modal";
import Toggle from "themes/elements/Toggle";
import ModalFooter from "../modalFooter";

import { setProfileView } from "pages/Councillors/counsilorSlice";

function CouncillorManagement({
  open,
  setOpen,
  isEdit,
  data,
  fetchCouncillor,
  fetchCouncillors,
}) {
  const dispatch = useDispatch();

  const [isActive, setIsActive] = useState(
    data?.councilor_status_flg === 1 ? true : false || false
  );
  const [formData, setFormData] = useState({
    firstName: isEdit ? data?.firstName : "",
    lastName: isEdit ? data?.lastName : "",
    email: isEdit ? data?.email : "",
    phone: isEdit ? data?.phone : "",
    isActive: isEdit
      ? data?.councilor_status_flg === 1
        ? true
        : false
      : false,
  });

  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  const handleToggleActive = () => setIsActive(!isActive);

  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    email: false,
    phone: false,
  });

  useEffect(() => {
    if (isEdit && data) {
      setFormData({
        firstName: data.first_name,
        lastName: data.last_name,
        email: data.email,
        phone: data.phone_number,
        active: data?.councilor_status_flg === 1 ? true : false,
      });
      setIsActive(data?.councilor_status_flg === 1 ? true : false);
    } else {
      setFormData({
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        active: false,
      });
      setIsActive(false);
    }
  }, [data, isEdit, open]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName) {
      newErrors.firstName = "First name is required.";
    }
    if (!formData.lastName) {
      newErrors.lastName = "Last name is required.";
    }
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }
    if (!formData.phone) {
      newErrors.phone = "Phone number is required.";
    } else if (formData.phone.length < 9) {
      newErrors.phone = "Phone number must be at least 9 digits.";
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = "Phone number must contain only digits.";
    }

    setErrors(newErrors);
    return newErrors; // Return the errors object instead of a boolean
  };

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: false,
      }));
    }
  };

  const handleSave = async (type) => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      // Display the first error found
      toast.error(Object.values(formErrors)[0]);
      return;
    }
    const loaderSetter =
      type === "profile" ? setLoadingProfile : setLoadingSave;
    loaderSetter(true);

    const payload = {
      action: isEdit ? "update" : "create",
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      email: formData?.email,
      phoneNumber: formData?.phone,
    };

    if (isEdit && data) {
      payload.councilorId = data.councilor_id;
      payload.status = isActive ? 1 : 0;
    }

    try {
      const res = await modifyCounsilors(payload);
      if (res) {
        // Wait for fetchCouncillor to finish
        await fetchCouncillor(res?.data?.councilor_id);
        await fetchCouncillors();
        // Now proceed with the state changes
        if (type === "profile") {
          dispatch(setProfileView(true));
        }
        toast.success(res.message);

        setOpen(false);
      }
    } catch (error) {
    } finally {
      loaderSetter(false);
    }
  };

  return (
    <>
      <ModalComp
        title={isEdit ? "Edit councillor" : "Add a new councillor"}
        footer={
          <ModalFooter
            handlePrimaryBtn={() => {
              isEdit ? setOpen(false) : handleSave("save");
            }}
            handleSecondaryBtn={() =>
              isEdit ? handleSave("save") : handleSave("profile")
            }
            primaryBtnVariant="secondary"
            primaryBtnText={isEdit ? "Cancel" : "Save"}
            secondaryBtnText={isEdit ? "Save" : "Complete profile"}
            primaryBtnloading={isEdit ? false : loadingSave}
            secondaryBtnLoading={isEdit ? loadingSave : loadingProfile}
          />
        }
        open={open}
        setOpen={setOpen}
      >
        <div className="flex gap-4 flex-column">
          <div className="flex gap-4 align-center">
            <InputComp
              maxLength={25}
              showCount
              value={formData?.firstName}
              onChange={(e) => handleInputChange("firstName", e.target.value)}
              layoutClass="w-full"
              placeholder="First name"
              label="First name"
              error={errors.firstName && "First name is required"}
            />
            <InputComp
              maxLength={25}
              showCount
              value={formData?.lastName}
              onChange={(e) => handleInputChange("lastName", e.target.value)}
              layoutClass="w-full"
              placeholder="Last name"
              label="Last name"
              error={errors.lastName && "Last name is required"}
            />
          </div>
          <div className="flex gap-4 align-center">
            <InputComp
              maxLength={50}
              showCount
              value={formData?.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              layoutClass="w-full"
              placeholder="Enter Email Address"
              label="Email"
              error={errors.email && "Email is required"}
            />
            <InputPhoneNumber
              maxLength={10}
              showCount
              type="number"
              value={formData.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              layoutClass="w-full"
              placeholder="Enter phone number"
              label="Phone"
              error={errors.phone && "Phone number is required"}
            />
          </div>
          {isEdit && (
            <Toggle
              isSmall
              active={isActive}
              onChange={handleToggleActive}
              label="Active"
            />
          )}
        </div>
      </ModalComp>
    </>
  );
}

export default CouncillorManagement;
